<template>
    <div>
        <md-card-content>
            <md-table :value="demands" class="paginated-table" table-header-color="blue" v-if="demands.length > 0">
                <md-table-toolbar>
                    <md-field>
                        <label for="pages">Éléments à afficher</label>
                        <md-select v-model="pagination.perPage" name="pages">
                            <md-option
                                v-for="item in pagination.perPageOptions"
                                :key="item" :label="item" :value="item">
                                {{ item }}
                            </md-option>
                        </md-select>
                    </md-field>
                </md-table-toolbar>

                <md-table-row slot="md-table-row" slot-scope="{ item }">
                    <md-table-cell md-label="Créateur">
                        <div class="flex items-center">
                            <div class="creator-cube" :style="{ backgroundColor: item.creator.color }"></div>
                            <span class="ml-2 leading-none font-medium">{{ item.creator.first_name }}</span>
                        </div>
                    </md-table-cell>
                    <md-table-cell md-label="Date">
                        {{ $moment(item.date).format('DD/MM/YYYY HH:mm') }}
                    </md-table-cell>
                    <md-table-cell md-label="Demande" style="min-width: 600px;">
                        <div class="w-full text-left">
                            <p>
                                {{ item.site.name }} - État :
                                <span :class="item.status === 0 ? 'text-danger' : (item.status === 1 ? 'text-success' : 'text-warning')">
                                    {{ statusDemand(item.status) }}
                                </span>
                            </p>
                            <div class="flex items-center">
                                <div class="mr-3">
                                    <md-button class="md-icon-button md-default">
                                        <font-awesome-icon class="md-icon" :icon="['fa', 'info']" />
                                    </md-button>
                                    <md-tooltip md-direction="top" style="min-width: 350px !important;">
                                        <div>
                                            <b>Message : </b>
                                            {{ item.message }}
                                        </div>
                                    </md-tooltip>
                                </div>
                                <span class="text-info cursor-pointer" @click="goToRoute('Demand Details', { demandId: item.id })">
                                {{ item.subject }}
                            </span>
                            </div>
                        </div>
                    </md-table-cell>
                </md-table-row>
            </md-table>
            <p v-else>Aucune demande pour ce site</p>
        </md-card-content>
        <md-card-actions md-alignment="space-between" v-if="demands.length > 0">
            <p class="card-category">
                Affichage des éléments {{ from + 1 }} à {{ to }} sur {{ pagination.total }} éléments
            </p>
            <pagination
                class="pagination-no-border pagination-info"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="pagination.total"
                @input="getDemands"
            >
            </pagination>
        </md-card-actions>
    </div>
</template>

<script>
import { Pagination } from "@/components";
export default {
    name: "SiteDemands",
    components: {
        Pagination
    },
    data() {
        return {
            demands: [],
            pagination: {
                perPage: 10,
                currentPage: 1,
                perPageOptions: [10, 25, 50],
                total: 0
            },
        }
    },
    computed: {
        to() {
            let highBound = this.from + this.pagination.perPage;
            if (this.pagination.total < highBound) {
                highBound = this.pagination.total;
            }
            return highBound;
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total() {
            return this.searchedData.length > 0
                ? this.searchedData.length
                : this.demands.length;
        },
    },
    methods: {
        async getDemands() {
            const response = await this.$store.dispatch('demands/fetchByClientOrSite', {
                page: this.pagination.currentPage,
                perPage: this.pagination.perPage,
                site_id: parseInt(this.$route.params.idSite)
            })
            this.demands = response.data.data
            this.pagination.total = response.data.total
        },
        statusDemand(status) {
            return status === 0 ? 'Non traitée' : status === 1 ? 'Traitée' : 'En attente'
        },
        goToRoute(route, params) {
            this.$router.push({ name: route, params })
        }
    },
    mounted() {
        this.getDemands()
    }
}
</script>

<style scoped lang="scss">
.creator-cube {
    width: 12px;
    height: 12px;
    border-radius: 3px;
}

::v-deep {
    .paginated-table .md-table-head:last-child {
        text-align: left !important;
        justify-content: flex-start !important;
    }
}
</style>
